import Service from "../../Services";

const Permission = {
  namespaced: true,
  state: {
    form: {
      id : '',
      name : '',
    }
  },
  mutations: {
    GET_FORM: (state, res) => {
      state.form = res;
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        id : '',
        name : '',
      };
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getPermission({ commit }, page) {
      return Service.PermissionAPI.getPermission(page);
    },
    // eslint-disable-next-line no-unused-vars
    showPermission({ commit }, id) {
      return Service.PermissionAPI.showPermission(id);
    },
    // eslint-disable-next-line no-unused-vars
    savePermission({ commit }, { id, data }) {
      if (id) {
        return Service.PermissionAPI.updatePermission(id, data);
      } else {
        return Service.PermissionAPI.createPermission(data);
      }
    },
    // eslint-disable-next-line no-unused-vars
    deletePermission({ commit }, id) {
      return Service.PermissionAPI.deletePermission(id);
    },
    getAllPermission({commit}){
      return Service.PermissionAPI.getAllPermission();
    },
    setFormPermission({ commit }, res) {
      commit("GET_FORM", res);
    },
    clearFormData({ commit }) {
      commit("CLEAR_FORM_DATA");
    },
  }
};
export default Permission;
